<template>
    <div style="width: 100%">
        <div style="width: 100%;height: 30px;background-color: #e3e3e3;display: flex;font-size: 13px">
            <div style="margin: auto 0;color: #595a5a;padding-left: 20px"><span >当前位置：</span></div>
            <el-breadcrumb separator-class="el-icon-arrow-right" style="margin: auto 0;font-size: 13px">
                <el-breadcrumb-item v-for="(item,index) in $route.meta.position" :key="index">
                    {{item}}
                </el-breadcrumb-item>
            </el-breadcrumb>
        </div>
        <!-- 基本信息 -->
        <div style="background-color: #FFFFFF;">
            <el-container>
                <!-- 主内容 -->
                <el-main>
                    <el-form ref="form" :model="form" label-width="80px"
                             style="margin-left: 50px">
                        <el-row>
                            <el-col :span="8">
                                <el-form-item label="供应商: ">
                                    <el-input v-model="form.gys" style="width: 300px"></el-input>
                                </el-form-item>
                            </el-col>
                            <el-col :span="8">
                                <el-form-item label="商品SKU: ">
                                    <el-input v-model="form.sku" style="width: 300px"></el-input>
                                </el-form-item>
                            </el-col>
                            <el-col :span="8">
                                <el-form-item label="商品名称: ">
                                    <el-input v-model="form.name" style="width: 300px"></el-input>
                                </el-form-item>
                            </el-col>
                        </el-row>
                        <el-form-item style="text-align: right">
                            <el-button type="primary">重置</el-button>
                            <el-button type="primary" plain>搜索</el-button>
                        </el-form-item>
                    </el-form>
                </el-main>
            </el-container>
        </div>
        <div style="margin-top: 10px;background-color: white">
            <template>
                <el-table
                        :data="tableData"
                        border
                        style="width: 100%"
                        :header-cell-style="{background:'#B0C4DE',color:'#595a5a'}">
                    <el-table-column
                            type="selection"
                            width="55">
                    </el-table-column>
                    <el-table-column
                            prop="date"
                            label="主图" align="center">
                        <template slot-scope="scope">
                            <img :src="scope.row.img" width="100" height="100"/>
                        </template>
                    </el-table-column>
                    <el-table-column
                            prop="name"
                            label="商品名称" align="center">
                    </el-table-column>
                    <el-table-column
                            prop="address"
                            label="供应商" align="center">
                    </el-table-column>
                </el-table>
                <template>
                    <div class="block" style="text-align: right">
                        <el-pagination
                                @size-change="handleSizeChange"
                                @current-change="handleCurrentChange"
                                :current-page.sync="currentPage1"
                                :page-size="100"
                                layout="total, prev, pager, next"
                                :total="1000">
                        </el-pagination>
                    </div>
                </template>
            </template>
        </div>
    </div>
</template>

<script>
    export default {
        data: function () {
            return {
                form: {
                    gys: '',
                    sku: '',
                    name: '',
                },
                page:{
                    currentPage1: 5,
                },
                tableData: [{
                    img: 'https://dss0.bdstatic.com/70cFuHSh_Q1YnxGkpoWK1HF6hhy/it/u=1906469856,4113625838&fm=26&gp=0.jpg',
                    name: '王小虎',
                    address: '上海市普陀区金沙江路 1518 弄'
                }, {
                    img: 'https://dss0.bdstatic.com/70cFuHSh_Q1YnxGkpoWK1HF6hhy/it/u=1906469856,4113625838&fm=26&gp=0.jpg',
                    name: '王小虎',
                    address: '上海市普陀区金沙江路 1517 弄'
                }, {
                    img: 'https://dss0.bdstatic.com/70cFuHSh_Q1YnxGkpoWK1HF6hhy/it/u=1906469856,4113625838&fm=26&gp=0.jpg',
                    name: '王小虎',
                    address: '上海市普陀区金沙江路 1519 弄'
                }, {
                    img: 'https://dss0.bdstatic.com/70cFuHSh_Q1YnxGkpoWK1HF6hhy/it/u=1906469856,4113625838&fm=26&gp=0.jpg',
                    name: '王小虎',
                    address: '上海市普陀区金沙江路 1516 弄'
                }]
            };
        },
        methods: {
            handleSizeChange(val) {
                console.log(`每页 ${val} 条`);
            },
            handleCurrentChange(val) {
                console.log(`当前页: ${val}`);
            }
        }
    }
</script>

<style>
    .head .el-dialog__header {
        background-color: #eef1f6;
    }
</style>
